module.exports = __webpack_public_path__ + "img/2.67dc7c31.jpg";